"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _UnreachableCaseError = require("../../entities/UnreachableCaseError");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getVariantCss = function getVariantCss(variant) {
  switch (variant) {
    case 'small':
      return (0, _styledComponents.css)(["font-size:12px;"]);
    case 'regular':
      return (0, _styledComponents.css)(["font-size:14px;"]);
    case 'large':
      return (0, _styledComponents.css)(["font-size:17px;"]);
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
var Label = exports.Label = _styledComponents["default"].label.withConfig({
  displayName: "Label",
  componentId: "sc-jxivt4-0"
})(["font-weight:500;letter-spacing:0.15px;line-height:16px;margin:0.4rem 0;", ";"], function (_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'regular' : _ref$variant;
  return getVariantCss(variant);
});
//# sourceMappingURL=Label.js.map